export default __webpack_public_path__ + "static/media/LeticiaNnamani.24064430.svg";